module.exports = __webpack_public_path__ + "static/media/shareKakaotalk.e62cb39c.webp";